import * as settings from './appsettings.json';

const API_URL = settings.API_URL;

export const API_URL_VALIDATE_TICKET = `${API_URL}pos/processticket`
export const API_URL_TICKET_ARTICLES = `${API_URL}article/listticketarticlesforpos`
export const API_URL_TICKET_CUSTOMERS = `${API_URL}customer/listticketcustomers`

export const VALIDATED_TICKET = 'VALIDATED_TICKET'
export const SET_BARCODE = 'SET_BARCODE'
export const CLEAR_VALIDATION = 'CLEAR_VALIDATION'
export const CLEAR_BARCODE = 'CLEAR_BARCODE'
export const USE_MANUAL_INPUT = 'USE_MANUAL_INPUT'
export const SET_OVERRIDE_MODAL = 'SET_OVERRIDE_MODAL'
export const SET_OVERRIDE_MODAL_VIEW = 'SET_OVERRIDE_MODAL_VIEW'
export const SET_TICKET_REFERENCE = 'SET_TICKET_REFERENCE'
export const TICKET_ARTICLES_FETCHED = 'TICKET_ARTICLES_FETCHED'
export const TICKET_CUSTOMERS_FETCHED = 'TICKET_CUSTOMERS_FETCHED'
export const SET_TICKET_QUANTITY = 'SET_TICKET_QUANTITY'
export const TOGGLE_SELECTED_CUSTOMER = 'TOGGLE_SELECTED_CUSTOMER'
export const CLEAR_STATE = 'CLEAR_STATE'


// WEBPACK FOOTER //
// src/constants/Tickets.js